/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { change_requests_ChangeRequestField } from './change_requests_ChangeRequestField';
export type change_requests_InitiateChildDataUpdateRequest = {
    change?: change_requests_ChangeRequestField;
    child_ids: Array<string>;
    source_kind?: change_requests_InitiateChildDataUpdateRequest.source_kind;
    sub_type: change_requests_InitiateChildDataUpdateRequest.sub_type;
};
export namespace change_requests_InitiateChildDataUpdateRequest {
    export enum source_kind {
        WEB_ADMIN = 'web_admin',
        EMAIL = 'email',
        APP = 'app',
    }
    export enum sub_type {
        COMMENT = 'comment',
        ALLERGY = 'allergy',
        MEDICAL = 'medical',
        CONTACT_PICKUP = 'contact_pickup',
        CONTACT_EMERGENCY = 'contact_emergency',
    }
}

